import { Node } from '@cast/types';

export const getNodeConfigurationName = (node: Node): string | undefined =>
  node.labels?.['provisioner.cast.ai/node-configuration-name'];

export const getNodeConfigurationVersion = (node: Node): string | undefined =>
  node.labels?.['provisioner.cast.ai/node-configuration-version'];
